import { AddCircleRounded } from "@mui/icons-material";
import { Button } from "@mui/material";

export const AddButton = ({ children }) => {
  return (
    <Button
      variant="contained"
      disableElevation
      startIcon={<AddCircleRounded />}
    >
      <div className="capitalize">{children}</div>
    </Button>
  );
};
